/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Slug_TakenInputs */

const en_sch_err_slug_taken = /** @type {(inputs: Sch_Err_Slug_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This key is already taken. Change the English name or the key.`)
};

const de_sch_err_slug_taken = /** @type {(inputs: Sch_Err_Slug_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Schlüssel gibt es schon. Ändere den englischen Namen oder den Schlüssel.`)
};

/**
* | output |
* | --- |
* | "This key is already taken. Change the English name or the key." |
*
* @param {Sch_Err_Slug_TakenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_slug_taken = /** @type {((inputs?: Sch_Err_Slug_TakenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Slug_TakenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_slug_taken(inputs)
	return en_sch_err_slug_taken(inputs)
});